import { GetBankLinkTokenQuery, GetBankLinkTokenQueryVariables } from "@ctypes";
import { GET_BANK_LINK_TOKEN } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useBankLinkToken = (variables?: GetBankLinkTokenQueryVariables) => {
  const { data: queryData, ...rest } = useQuery<
    GetBankLinkTokenQuery,
    GetBankLinkTokenQueryVariables
  >(GET_BANK_LINK_TOKEN, {
    variables,
  });

  const token = queryData?.getBankLinkToken?.token;

  return { token, ...rest };
};
